<script>
import { BAvatarGroup } from "bootstrap-vue";

export default {
  extends: BAvatarGroup
};
</script>